export const workNotes = {
  addWorkNote: "Worknote hinzufügen",
  workNote: "Worknote",
  validationRequired:
    "Es ist erforderlich vor dem Speichern eine Worknote einzugeben"
};
